/* SearchForecast.js – standalone component you can import at the top of App.js */
/* Needs Tailwind for styles */

import React, { useEffect, useRef, useState } from "react";

const HOST         = "https://n8n.193.122.13.148.nip.io";   // <-- my n8n base
const API_SEARCH   = `${HOST}/webhook/searchBeaches?q=`;
const API_FORECAST = `${HOST}/webhook/getJSONForecast?beach=`;

export default function SearchForecast({ onForecast }) {
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const delayRef = useRef();
  const controllerRef = useRef();

  /* Load last beach on first mount */
  useEffect(() => {
    const cached = JSON.parse(localStorage.getItem("lastBeach") || "null");
    if (cached) fetchForecast(cached);
  }, []);

  /* Debounce query */
  useEffect(() => {
    clearTimeout(delayRef.current);
    if (!query) return setSuggestions([]);

    delayRef.current = setTimeout(() => {
      controllerRef.current?.abort();
      const controller = new AbortController();
      controllerRef.current = controller;

      setLoading(true);
      fetch(API_SEARCH + encodeURIComponent(query), { signal: controller.signal })
        .then(r => r.json())
        .then(setSuggestions)
        .catch(() => {})           // ignore abort errors
        .finally(() => setLoading(false));
    }, 250);
  }, [query]);

  const fetchForecast = (beach) => {
    setQuery(beach.name);
    setSuggestions([]);
    localStorage.setItem("lastBeach", JSON.stringify(beach));

    fetch(API_FORECAST + beach.id)
      .then(async (r) => {
      const text = await r.text();
      try {
        return JSON.parse(text);
      } catch (e) {
        console.warn("Empty or invalid JSON from backend:", text);
        return []; // fallback: empty forecast
      }
    })
	  .then(onForecast)
      .catch(console.error);
  };

  return (
    <div className="relative w-72 mx-auto mb-6">
      <input
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Search beach..."
        className="w-full rounded bg-gray-800 text-white px-3 py-2"
      />
      {loading && <span className="absolute right-3 top-3 animate-pulse">…</span>}

      {suggestions.length > 0 && (
        <ul className="absolute left-0 right-0 bg-gray-900 max-h-56 overflow-y-auto border border-gray-700 z-10">
          {suggestions.map((b) => (
            <li
              key={b.id}
              className="px-3 py-2 hover:bg-gray-700 cursor-pointer"
              onClick={() => fetchForecast(b)}
            >
              {b.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
